export default "__VITE_ASSET__28IjTW7O__"